import React from 'react';

type Props = {
  onClick: () => void;
};

export const TestimonialsFormInner = ({ onClick }: Props) => (
  <div className="testimonials_form_inner">
    <div className="testimonial_form_title">
      Отзывы о Level.Travel – сервисе покупки туров онлайн
      <button type="button" onClick={onClick} className="add_comment stylized">
        <i className="lt-icon-comments" />
        Оставить отзыв
      </button>
    </div>
  </div>
);
